import {
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import CardHeaderComponent from "./CardHeaderComponent";
import { salaryrangeOptions, hourlyrateOptions } from "./CandidateForm.Config";
import countryList from "../invoiceComponents/data/countryList";

const CandidateLookingFor = ({ handleChange, formData }) => {
  const salaryOptions = salaryrangeOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  const hourlyOptions = hourlyrateOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  const countryOptions = countryList.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={SearchIcon} title="Looking For" />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={salaryOptions}
              label="Salary Range"
              name="salary_range"
              value={formData?.salary_range || ""}
              onChange={handleChange}
              placeholder="Select Salary Range"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={hourlyOptions}
              label="Hourly Rate"
              name="hourly_rate"
              value={formData?.hourly_rate || ""}
              onChange={handleChange}
              placeholder="Select Hourly Rate"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={countryOptions}
              label="Requested Region"
              name="requested_region"
              value={formData?.requested_region || ""}
              onChange={handleChange}
              placeholder="Select Region"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateLookingFor;